var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-rich-marker',{attrs:{"marker":_vm.marker}},[_c('div',{staticClass:"status-item-pin"},[_c('div',{staticClass:"status-item-pin-icon",class:_vm.iconClass}),_vm._v(" "),_c('div',{staticClass:"status-item-pin-count"},[_vm._v(_vm._s(_vm.marker.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }